import { CircleCheck, CircleX, Info, LoaderCircle, TriangleAlert } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      icons={{
        success: <CircleCheck className="size-4" />,
        info: <Info className="size-4" />,
        warning: <TriangleAlert className="size-4" />,
        error: <CircleX className="size-4" />,
        loading: <LoaderCircle className="size-4 animate-spin" />
      }}
      style={
        {
          '--border-radius': 'var(--radius-md)',
          '--normal-bg': 'var(--color-background)',
          '--normal-text': 'var(--color-typography-900)',
          '--normal-border': 'var(--color-border)',
          '--success-bg': 'var(--color-success-50)',
          '--success-text': 'var(--color-success-800)',
          '--success-border': 'var(--color-success-200)',
          '--error-bg': 'var(--color-error-100)',
          '--error-text': 'var(--color-error-500)',
          '--error-border': 'var(--color-error-200)',
          '--warning-bg': 'var(--color-warning-100)',
          '--warning-text': 'var(--color-warning-800)',
          '--warning-border': 'var(--color-warning-200)',
          '--info-bg': 'var(--color-primary-100)',
          '--info-text': 'var(--color-primary-900)',
          '--info-border': 'var(--color-primary-500)'
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
